export class ReviewItem {
  public reviewTitle: string;
  public reviewName: string;
}
